import { CMS_MICROSITE_ID } from '@lyrahealth-inc/shared-app-logic'

import { useCheckUserGoogleCriticalTalent } from '../useCheckUserGoogleCriticalTalent'

/**
 * Run any hooks that are specific to a single microsite
 */
export const useRunMicrositeSpecificHooks = (micrositeId: CMS_MICROSITE_ID) => {
  useCheckUserGoogleCriticalTalent({ shouldCheck: micrositeId === CMS_MICROSITE_ID.GOOGLE_PERFORMANCE })
}
